import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

const SettingsLayout = () => {
  return (
    <Box w="full" px={{ base: 4, xl: 6 }} py={{ base: 6, md: 10 }}>
      <Outlet />
    </Box>
  );
};

export default SettingsLayout;
